/**
 * useExtraReview — данные окна «Проверка допработ за период» (10.10.2026, владелец).
 * Два запроса: все допработы периода любых статусов (заявки, возвраты, отклонённые, учёбки)
 * и зарплатный расчёт того же периода — из него игры, админства и суммы, которые реально
 * уйдут в зарплату. Перезагрузка после действия не прячет список (без мигания).
 */
import { useCallback, useEffect, useState } from "react";
import { api } from "../api/client";
import type { ApiList } from "../api/types";
import { toExtraWork, type ExtraWork, type RawEw } from "./useExtraWork";
import type { SalaryResp } from "../screens/oo/extraReviewModel";
import { addDays, fmtDateApi, parseDateApi } from "../utils/date";

export function useExtraReview(from: string, to: string) {
  const [works, setWorks] = useState<ExtraWork[]>([]);
  const [sal, setSal] = useState<SalaryResp>({});
  const [loaded, setLoaded] = useState<string | null>(null); /* для какого периода данные на экране */
  const [error, setError] = useState<string | null>(null);
  const [tick, setTick] = useState(0);
  const reload = useCallback(() => setTick((n) => n + 1), []);

  useEffect(() => {
    let alive = true;
    setError(null);
    Promise.all([
      api<ApiList<RawEw>>(`/api/extra-work?from=${from}&to=${to}`),
      /* +1 день: ночные игры последнего дня записаны следующей датой (см. buildReview) */
      api<SalaryResp>(`/api/finance/salary?from=${from}&to=${fmtDateApi(addDays(parseDateApi(to), 1))}`),
    ])
      .then(([w, s]) => {
        if (!alive) return;
        setWorks((w.results ?? []).map(toExtraWork));
        setSal(s);
        setLoaded(`${from}|${to}`);
      })
      .catch((e: unknown) => { if (alive) setError(e instanceof Error ? e.message : "Не загрузилось"); });
    return () => { alive = false; };
  }, [from, to, tick]);

  return { works, sal, loading: loaded !== `${from}|${to}`, error, reload };
}
